import { render, staticRenderFns } from "./WeightCalculationRules.vue?vue&type=template&id=46c59dbe&scoped=true&"
import script from "./WeightCalculationRules.vue?vue&type=script&lang=js&"
export * from "./WeightCalculationRules.vue?vue&type=script&lang=js&"
import style0 from "./WeightCalculationRules.vue?vue&type=style&index=0&id=46c59dbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c59dbe",
  null
  
)

export default component.exports